import sortBy from "lodash/sortBy";
import {
  IPayerEngagementResponse,
  PayerPayeeEngagementStatus
} from "@wingspanhq/payments/dist/interfaces";
import uniqBy from "lodash/uniqBy";
import { RequirementTableItemData } from "../types";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";

export const selectorUniqRequirementsFromEngagementsList = (
  engagements: Array<IPayeeEngagementResponse | IPayerEngagementResponse>
) => {
  const allRequirements = sortBy<RequirementTableItemData>(
    engagements
      .filter(
        engagement => engagement.status === PayerPayeeEngagementStatus.Active
      )
      .map(engagement => engagement.requirements)
      .flat(),
    "engagementName"
  );

  const uniqRequirements = uniqBy(allRequirements, requirement => {
    return requirement.requirementDefinitionId;
  });

  const uniqRequirementsWithEngagementIds = uniqRequirements.map(
    requirement => {
      return {
        ...requirement,
        engagementId: engagements.find(engagement =>
          (engagement.requirements || []).includes(requirement)
        )!.payerPayeeEngagementId
      };
    }
  );

  const uniqRequirementsWithRelatedEngagementIds =
    uniqRequirementsWithEngagementIds.map(requirement => {
      const relatedEngagementRequirementIds = engagements
        .map(engagement => {
          const matchingRequirement = engagement.requirements?.find(
            req =>
              req.requirementDefinitionId ===
              requirement.requirementDefinitionId
          );

          return matchingRequirement
            ? {
                engagementId: engagement.payerPayeeEngagementId,
                relatedRequirementId: matchingRequirement.requirementId
              }
            : null;
        })
        .filter(Boolean);

      return {
        ...requirement,
        relatedEngagementRequirementIds
      };
    });

  return uniqRequirementsWithRelatedEngagementIds;
};
